export const getSidebarItems = (router) => [
  {
    isPrimary: true,
    key: 'DashboardPage',
    label: 'Dashboard',
    icon: 'pi pi-briefcase',
    permission: 'view dashboard',
    command: () => {
      router.push({ name: 'DashboardPage' })
    },
  },
  {
    isPrimary: true,
    key: 'UsersParent',
    label: 'User',
    icon: 'pi pi-user',
    permission: 'view users',
    items: [
      {
        key: 'AddUserPage',
        label: 'Add User',
        icon: 'pi pi-user-plus',
        permission: 'add user',
        command: () => {
          router.push({ name: 'AddUserPage' })
        },
      },
      {
        key: 'UsersPage',
        label: 'Users',
        icon: 'pi pi-users',
        permission: 'view users',
        command: () => {
          router.push({ name: 'UsersPage' })
        },
      },
      {
        key: 'UserRolesPage',
        label: 'User Roles',
        icon: 'pi pi-user-edit',
        permission: 'manage roles',
        command: () => {
          router.push({ name: 'UserRolesPage' })
        },
      },
    ],
  },
  {
    isPrimary: true,
    key: 'SuppliersParent',
    label: 'Supplier',
    icon: 'pi pi-box',
    items: [
      {
        key: 'AddSupplierPage',
        icon: 'pi pi-plus',
        label: 'Add Supplier',
        permission: 'add supplier',
        command: () => {
          router.push({ name: 'AddSupplierPage' })
        },
      },
      {
        key: 'SuppliersPage',
        icon: 'pi pi-box',
        label: 'Suppliers',
        permission: 'view suppliers',
        command: () => {
          router.push({ name: 'SuppliersPage' })
        },
      },
      {
        key: 'UploadStockListPage',
        icon: 'pi pi-list-check',
        label: 'Upload StockList',
        permission: 'upload stock list',
        command: () => {
          router.push({ name: 'UploadStockListPage' })
        },
      },
      {
        key: 'StocklistPage',
        icon: 'pi pi-list',
        label: 'StockList',
        permission: 'view stock list',
        command: () => {
          router.push({ name: 'StocklistPage' })
        },
      },
    ],
  },
  {
    isPrimary: true,
    key: 'CustomersParent',
    label: 'Customer',
    icon: 'pi pi-address-book',
    items: [
      {
        key: 'AddCustomerPage',
        label: 'Add Customer',
        icon: 'pi pi-plus',
        permission: 'add customer',
        command: () => {
          router.push({ name: 'AddCustomerPage' })
        },
      },
      {
        key: 'CustomersPage',
        label: 'Customers',
        icon: 'pi pi-address-book',
        permission: 'view customers',
        command: () => {
          router.push({ name: 'CustomersPage' })
        },
      },
    ],
  },
  {
    isPrimary: true,
    key: 'EqoParent',
    label: 'EQO',
    icon: 'pi pi-envelope',
    items: [
      {
        key: 'PartSourcingPage',
        icon: 'pi pi-align-left',
        label: 'Part Sourcing',
        permission: 'view part sourcing page',
        command: () => {
          router.push({ name: 'PartSourcingPage' })
        },
      },
      {
        key: 'AddEnquiryPage',
        icon: 'pi pi-plus',
        label: 'Add Enquiry',
        permission: 'add enquiry',
        command: () => {
          router.push({ name: 'AddEnquiryPage' })
        },
      },
      {
        key: 'EqoListPage',
        icon: 'pi pi-inbox',
        label: 'EQO',
        permission: 'view eqo',
        command: () => {
          router.push({ name: 'EqoListPage', query: { status: 'general' } })
        },
      },
      {
        key: 'OrderHistoryPage',
        icon: 'pi pi-history',
        label: 'Order History',
        permission: 'view order history',
        command: () => {
          router.push({ name: 'OrderHistoryPage', query: { status: 'general' } })
        },
      },
    ],
  },
  {
    isPrimary: true,
    key: '5',
    label: 'Warehouse',
    icon: 'pi pi-warehouse',
    items: [
      {
        key: '5_1',
        icon: 'pi pi-arrow-down-left',
        label: 'Inbound',
        permission: 'view inbound',
      },
      {
        key: '5_2',
        icon: 'pi pi-arrow-down',
        label: 'Received',
        permission: 'view received',
      },
      {
        key: '5_3',
        icon: 'pi pi-arrow-up-right',
        label: 'Outbound',
        permission: 'view outbound',
      },
    ],
  },
  {
    isPrimary: true,
    key: 'ManageFinance',
    label: 'Finance',
    icon: 'pi pi-wallet',
    permission: 'manage finance',
  },
  {
    isPrimary: true,
    key: 'PurchaseAnalysisParent',
    label: 'Purchase Analysis',
    icon: 'pi pi-chart-bar',
    items: [
      {
        key: 'PurchaseAnalysisOrderPage',
        label: 'Order',
        icon: 'pi pi-shopping-cart',
        permission: 'view purchase analysis',
        command: () => {
          router.push({ name: 'PurchaseAnalysisOrderPage' })
        },
      },
      {
        key: 'PurchaseAnalysisRepairPage',
        label: 'Repair',
        icon: 'pi pi-wrench',
        permission: 'view purchase analysis',
        command: () => {
          router.push({ name: 'PurchaseAnalysisRepairPage' })
        },
      },
    ],
  },
  {
    isPrimary: true,
    key: 'ManagePage',
    label: 'Page',
    icon: 'pi pi-book',
    items: [
      {
        key: '7_1',
        icon: 'pi pi-file',
        label: 'Pages',
        permission: 'view pages',
      },
    ],
  },
  {
    isPrimary: true,
    key: 'ManageStore',
    label: 'Store',
    icon: 'pi pi-shopping-cart',
    items: [
      {
        key: '8_1',
        icon: 'pi pi-shopping-cart',
        label: 'Products',
        permission: 'view products',
      },
      {
        key: '8_2',
        icon: 'pi pi-cart-arrow-down',
        label: 'Add Product',
        permission: 'add product',
      },
    ],
  },
  {
    isPrimary: true,
    key: 'WebsiteParent',
    label: 'Website',
    icon: 'pi pi-globe',
    items: [
      {
        key: 'AdminBlogPage',
        label: 'Blog',
        icon: 'pi pi-list',
        permission: 'manage blog',
        command: () => {
          router.push({ name: 'AdminBlogPage' })
        },
      },
      {
        key: 'AdminFaqPage',
        label: 'FAQ',
        icon: 'pi pi-question-circle',
        permission: 'manage faq',
        command: () => {
          router.push({ name: 'AdminFaqPage' })
        },
      },
      {
        key: 'AdminTeamContactAddressesPage',
        label: 'Team contact addresses',
        icon: 'pi pi-phone',
        permission: 'manage team contact addresses',
        command: () => {
          router.push({ name: 'AdminTeamContactAddressesPage' })
        },
      },
      {
        key: 'AdminPlantAddressesPage',
        label: 'Plant address and bank details',
        icon: 'pi pi-map-marker',
        permission: 'manage plant address and bank details',
        command: () => {
          router.push({ name: 'AdminPlantAddressesPage' })
        },
      },
      {
        key: 'AdminLegalDocumentsPage',
        label: 'Legal Documents',
        icon: 'pi pi-file-edit',
        permission: 'manage legal documents',
        command: () => {
          router.push({ name: 'AdminLegalDocumentsPage' })
        },
      },
      {
        key: 'StockListParent',
        label: 'Stock List',
        icon: 'pi pi-list',
        items: [
          {
            key: 'WebsiteUploadStockListPage',
            label: 'Upload Stock List',
            icon: 'pi pi-list-check',
            permission: 'upload website stock list',
            command: () => {
              router.push({ name: 'WebsiteUploadStockListPage' })
            },
          },
          {
            key: 'WebsiteStockListPage',
            label: 'Stock List',
            icon: 'pi pi-list',
            permission: 'view website stock list',
            command: () => {
              router.push({ name: 'WebsiteStocklistPage' })
            },
          },
        ],
      },
    ],
  },
  {
    isPrimary: true,
    key: 'SettingsParent',
    label: 'Settings',
    icon: 'pi pi-cog',
    items: [
      {
        key: 'UserSettingsParent',
        label: 'User',
        icon: 'pi pi-user',
        items: [
          {
            key: 'DepartmentsPage',
            label: 'Departments',
            icon: 'pi pi-building',
            permission: 'manage departments',
            command: () => {
              router.push({ name: 'DepartmentsPage' })
            },
          },
        ],
      },
      {
        key: 'SupplierSettingsParent',
        label: 'Supplier',
        icon: 'pi pi-box',
        items: [
          {
            key: 'AdminManufacturersPage',
            label: 'Manufacturers',
            icon: 'pi pi-hammer',
            permission: 'manage manufacturers',
            command: () => {
              router.push({ name: 'AdminManufacturersPage' })
            },
          },
        ],
      },
      {
        key: 'CustomerSettingsParent',
        label: 'Customer',
        icon: 'pi pi-address-book',
        items: [
          {
            key: 'DesignationsPage',
            label: 'Designations',
            icon: 'pi pi-id-card',
            permission: 'manage designations',
            command: () => {
              router.push({ name: 'DesignationsPage' })
            },
          },
          {
            key: 'IndustriesPage',
            label: 'Industries',
            icon: 'pi pi-building-columns',
            permission: 'manage industries',
            command: () => {
              router.push({ name: 'IndustriesPage' })
            },
          },
          {
            key: 'PaymentTermsPage',
            label: 'Payment Terms',
            icon: 'pi pi-calendar-clock',
            permission: 'manage payment terms',
            command: () => {
              router.push({ name: 'PaymentTermsPage' })
            },
          },
          {
            key: 'RegionsPage',
            label: 'Regions',
            icon: 'pi pi-map-marker',
            permission: 'manage regions',
            command: () => {
              router.push({ name: 'RegionsPage' })
            },
          },
          {
            key: 'SupplyTypesPage',
            label: 'Supply Types',
            icon: 'pi pi-box',
            permission: 'manage supply types',
            command: () => {
              router.push({ name: 'SupplyTypesPage' })
            },
          },
        ],
      },
      {
        key: 'EqoSettingsParent',
        label: 'EQO',
        icon: 'pi pi-envelope',
        items: [
          {
            key: 'CalendarPage',
            label: 'Calendar Holidays',
            icon: 'pi pi-calendar',
            permission: 'manage calendar',
            command: () => {
              router.push({ name: 'CalendarPage' })
            },
          },
          {
            key: 'CurrenciesPage',
            label: 'Currencies',
            icon: 'pi pi-dollar',
            permission: 'manage currencies',
            command: () => {
              router.push({ name: 'CurrenciesPage' })
            },
          },
          {
            key: 'EqoNotesPage',
            label: 'Default Notes',
            icon: 'pi pi-clipboard',
            permission: 'manage eqo notes',
            command: () => {
              router.push({ name: 'EqoNotesPage' })
            },
          },
          {
            key: 'DeliveryTypesPage',
            label: 'Delivery Types',
            icon: 'pi pi-truck',
            permission: 'manage delivery types',
            command: () => {
              router.push({ name: 'DeliveryTypesPage' })
            },
          },
          {
            key: 'LeadTimePage',
            label: 'Lead Time',
            icon: 'pi pi-clock',
            permission: 'manage lead time',
            command: () => {
              router.push({ name: 'LeadTimePage' })
            },
          },
          {
            key: 'OfficeAddressesPage',
            label: 'Office Addresses',
            icon: 'pi pi-home',
            permission: 'manage office addresses',
            command: () => {
              router.push({ name: 'OfficeAddressesPage' })
            },
          },
          {
            key: 'PartConditionsPage',
            label: 'Part Conditions',
            icon: 'pi pi-sparkles',
            permission: 'manage part conditions',
            command: () => {
              router.push({ name: 'PartConditionsPage' })
            },
          },
          {
            key: 'PaymentMethodsPage',
            label: 'Payment Methods',
            icon: 'pi pi-receipt',
            permission: 'manage payment methods',
            command: () => {
              router.push({ name: 'PaymentMethodsPage' })
            },
          },
          {
            key: 'WarrantyTermsPage',
            label: 'Warranty Terms',
            icon: 'pi pi-shield',
            permission: 'manage warranty terms',
            command: () => {
              router.push({ name: 'WarrantyTermsPage' })
            },
          },
          {
            key: 'PdfsPage',
            label: 'PDFs',
            icon: 'pi pi-file-pdf',
            permission: 'manage pdfs',
            command: () => {
              router.push({ name: 'PdfsPage' })
            },
          },
        ],
      },
      {
        key: 'ActivityLogsPage',
        label: 'Activity Logs',
        icon: 'pi pi-history',
        permission: 'view activity logs',
        command: () => {
          router.push({ name: 'ActivityLogsPage' })
        },
      },
      {
        key: 'DeviceLoginsPage',
        label: 'Device Logins',
        icon: 'pi pi-desktop',
        permission: 'manage device logins',
        command: () => {
          router.push({ name: 'DeviceLoginsPage' })
        },
      },
    ],
  },
]
